import { useEffect, useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { getDeliveryQuantity } from "../../redux/actions/marketOverview";
import { useDispatch, useSelector } from "react-redux";
import { getAssetExchangeNameFromMktSegId } from "../../utils/global_functions";
import  DeliveryQuantityChart from "./DeliveryQuantityChart"
import {
    WATCHLIST_GRID_INDEX,
    SCRIP_INSTRUMENTS,
} from "../../utils/global_variables";
import ZeroStates from "../ZeroStates";

const jtenantToken = 1;
const DeliveryQuantityBuildup = () => {
    const dispatch = useDispatch();

    const arrDeliveryQuantity = useSelector(
        (state) => state?.marketOverview?.arrDeliveryQuantity
    );
    const scripOverviewData = useSelector(
        (state) => state.marketOverview.scripOverviewData
    );
    const data = useMemo(() => {
        return {
            todayvol: parseFloat(arrDeliveryQuantity?.vol),
            yesterdayvol: parseFloat(arrDeliveryQuantity?.vol_prev),
            yesterdaydel: parseFloat(arrDeliveryQuantity?.del_prev),
            fivedayvol: parseFloat(arrDeliveryQuantity?.vol_5dayavg),
            fiveDaydel: parseFloat(arrDeliveryQuantity?.del_5dayavg),
            thirtyDayvol: parseFloat(arrDeliveryQuantity?.vol_30dayavg),
            thirtyDaydel: parseFloat(arrDeliveryQuantity?.del_30dayavg),
        };
    }, [arrDeliveryQuantity]);
    
    useEffect(() => {
        if (!arrDeliveryQuantity || arrDeliveryQuantity?.length === 0) {
            dispatch(
                getDeliveryQuantity({
                    mktSegmentId: getAssetExchangeNameFromMktSegId(
                        scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID]
                    ),
                    nToken:
                        scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT] ===
                            SCRIP_INSTRUMENTS?.EQUITIES
                            ? scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN]
                            : scripOverviewData[WATCHLIST_GRID_INDEX.ASSET_TOKEN],
                    jtenantToken: jtenantToken,
                })
            );
        } else {
        }
    }, [dispatch, arrDeliveryQuantity, scripOverviewData]);
    //Vaibhav Singh: BT-109089: 26-10-2023: added no data to display in case of api fail
    return (
        <>
            <Container fluid className='p-0 mt-3'>
                <div className='scripoverview-fieldset'>
                    <div className='scripoverview-legend'>DELIVERY QUANTITY BUILDUP</div> 
                    <div className='scripoverview-fieldset-sm'>
                        <Row className='g-0'>
                            <Col>                     
                                {arrDeliveryQuantity? Object?.keys(arrDeliveryQuantity)?.length?
                                <DeliveryQuantityChart data={data}/>
                                    :
                                    <div className='zero-state-alerts zero-state-alerts-lg'>
                                        <ZeroStates subText="Could not find any data" icon='icon-64 icon-nodata mb-3 mrgauto'/>
                                    </div>
                                    :<div className='zero-state-alerts zero-state-alerts-lg'>
                                        <ZeroStates subText="Could not find any data" icon='icon-64 icon-nodata mb-3 mrgauto'/>
                                    </div>
                                }                           
                            </Col>
                        </Row>
                    </div>    
                </div>                  
            </Container>
        </>
    );
};

export default DeliveryQuantityBuildup;
